"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDates = void 0;
var _dateFns = require("date-fns");
var getDates = function getDates(formData, fieldName, minFieldName, minExclusive, maxFieldName, maxExclusive) {
  var _a, _b, _c, _d, _e, _f;
  var compareDate = fieldName && ((_a = formData[fieldName]) === null || _a === void 0 ? void 0 : _a.value) ? new Date(String((_b = formData[fieldName]) === null || _b === void 0 ? void 0 : _b.value)) : undefined;
  var minDate = minFieldName && ((_c = formData[minFieldName]) === null || _c === void 0 ? void 0 : _c.value) ? new Date(String((_d = formData[minFieldName]) === null || _d === void 0 ? void 0 : _d.value)) : undefined;
  var maxDate = maxFieldName && ((_e = formData[maxFieldName]) === null || _e === void 0 ? void 0 : _e.value) ? new Date(String((_f = formData[maxFieldName]) === null || _f === void 0 ? void 0 : _f.value)) : undefined;
  minDate = minDate && minExclusive ? (0, _dateFns.addDays)(minDate, 1) : minDate;
  maxDate = maxDate && maxExclusive ? (0, _dateFns.subDays)(maxDate, 1) : maxDate;
  return {
    compareDate: compareDate,
    maxDate: maxDate,
    minDate: minDate
  };
};
exports.getDates = getDates;